// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyAOk8NtgDiVUNorqKTD_9zyWPVePhPcEeQ",
  authDomain: "flashgen-d531b.firebaseapp.com",
  projectId: "flashgen-d531b",
  storageBucket: "flashgen-d531b.firebasestorage.app",
  messagingSenderId: "2636344448",
  appId: "1:2636344448:web:a97e3e4b7a66f8b0274a65",
  measurementId: "G-WVXMGRBPSS"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db= getFirestore(app)
const analytics = getAnalytics(app);
export { db };